<mat-card class="card" [ngStyle]="cardStyle">
  <div class="card__text" [ngStyle]="style" [innerHTML]="content"></div>
</mat-card>
